import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { updateTripDetailsForAdminApi } from './updateTripDetailsForAdmin.api'
import updateTripDetailsForAdminInitialState from './updateTripDetailsForAdmin.initialState'
import {
  UpdateTripDetailsForAdminErrorResponse,
  UpdateTripDetailsForAdminRequestPayload
} from './updateTripDetailsForAdmin.types'

export const updateTripDetailsForAdmin = createAsyncThunk(
  urls.admin.updateTripDetailsForAdmin,
  async (payload: UpdateTripDetailsForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await updateTripDetailsForAdminApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const updateTripDetailsForAdminSlice = createSlice({
  name: urls.admin.updateTripDetailsForAdmin,
  initialState: updateTripDetailsForAdminInitialState,
  reducers: {
    resetUpdateTripDetailsForAdmin: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateTripDetailsForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(updateTripDetailsForAdmin.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(updateTripDetailsForAdmin.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as UpdateTripDetailsForAdminErrorResponse
        state.success = null
      })
  }
})

export const { actions: updateTripDetailsForAdminActions, reducer: updateTripDetailsForAdminReducer } =
  updateTripDetailsForAdminSlice

export const { resetUpdateTripDetailsForAdmin } = updateTripDetailsForAdminActions

export default updateTripDetailsForAdminSlice.reducer
